<div class="items">
  <div class="item" *ngFor="let occupiedStatus of legends">
    <div class="ico" [ngClass]="occupiedStatus.classKey.toLowerCase()"></div>
    <div class="label">{{ occupiedStatus.translationPath | translate }}</div>
  </div>
</div>